import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { api, ErrorResponse } from "@/utils/api";

export const useRemoveUser = (
  projectId: string,
  userExternalId: string,
  options: Omit<UseMutationOptions<void, ErrorResponse, void, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<void, ErrorResponse, void, unknown>({
    mutationFn: async (): Promise<void> => {
      await api.delete(`/projects/${projectId}/users/${userExternalId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "users"],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "users", userExternalId],
      });
    },
    ...options
  });
};
